import React from 'react'
import { Box, Card, Text, Group, SimpleGrid, Flex, Paper, Image, ThemeIcon, Title, Anchor, Menu, ActionIcon } from '@mantine/core'
import { IconBox, IconDotsVertical, IconPencil, IconTrash } from '@tabler/icons-react'
import NoImage from '../../../../../assets/img/images/no-images.png'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={150} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit Package
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete Package
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const PackageItemsList = ({ packageItems, actionMethod, showUser }) => {
  const navigate = useNavigate()

  const toDetailUser = (dataUser) => {
    if (dataUser !== null) {
      navigate(`/users/${dataUser.id}`)
    }
  }

  const listData = (data) => data.map((val, index) => {
    const remapOrderItems = (dataItems) => {
      if (dataItems.length > 0) {
        const remapItems = dataItems.map((val, index) => {
          return (
            <Box key={index} mb={4}>
              <Text fz={11} fw={500} mb={2}>{index + 1}. {val.name}</Text>
              <Text fz={11} fw={500} mb={2} c='gray.6' ml={11}>Product Quantity / Package: {val.qty} {val.qty_unit}</Text>
            </Box>
          )
        })
        return remapItems
      } else {
        return (
          <Box>
            <Text fz={12} fw='bold' color='gray.6'>No Items Available</Text>
          </Box>
        )
      }
    }

    const mappingDimensions = (dataDimension, unitDimension) => {
      if (dataDimension.length > 0) {
        const findWidth = dataDimension.find((val) => val.label === 'width')
        const findHeight = dataDimension.find((val) => val.label === 'height')
        const findLength = dataDimension.find((val) => val.label === 'length')

        return (
          <Box>
            <Text fz={12} fw='500'>{findWidth ? findWidth.value : 0} x {findHeight ? findHeight.value : 0} x {findLength ? findLength.value : 0} {unitDimension || ''}</Text>
          </Box>
        )
      } else {
        return (
          <Box>
            <Text fz={12} fw='500' color='gray.6'>No Dimension</Text>
          </Box>
        )
      }
    }

    const mappingShowUser = (showDataUser) => {
      if (showDataUser) {
        return (
          <>
            <Box>
                <Text fz={12} c='gray.6'>Created By</Text>
                <Anchor fz={13} underline="hover" c={val.creator !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.creator)}>{val.creator !== null ? val.creator.name : 'No User'}</Anchor>
                <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
            </Box>
            <Box>
              <Text fz={12} c='gray.6'>Updated By</Text>
              <Anchor fz={13} underline="hover" c={val.updater !== null ? 'blue' : 'gray.6'} mb={4} fw='500' onClick={() => toDetailUser(val.updater)}>{val.updater !== null ? val.updater.name : 'No User'}</Anchor>
              <Text fz={10} c='gray.6'>{dayjs(val.created_at).format('DD/MMMM/YYYY')} - { dayjs(val.created_at).format('HH:mm:ss')}</Text>
            </Box>
          </>
        )
      }
    }

    return (
      <Card key={index} shadow="sm" padding="lg" pb={0} radius="md" withBorder mb={20}>
        <Card.Section style={{ backgroundColor: '#eeefef' }} >
          <Group justify='space-between' align='center' p={12}>
            <Text fz={12} fw='bold' color='red'>Package marks no: {val.marks} {val.package_id !== undefined ? `( Package Shipment ID : ${val.package_id === 0 ? 'Not Found' : `${val.package_id}`} )` : ''}</Text>
            <ActionMenu handleAction={(type) => actionMethod(val, type)} />
          </Group>
        </Card.Section>
        <SimpleGrid cols={2} verticalSpacing="md" spacing="md">
          <Box style={{ borderRight: '2px solid #eeefef' }}>
            <Flex justify='space-between' align='flex-start'>
              <Flex gap='sm' align='start' py={10}>
                <Paper shadow="sm" w={82} mt={4} withBorder radius='md'>
                  <Image w={80} h={80} radius='md' src={val.images !== null ? val.images : NoImage} />
                </Paper>
                <Box mt={4} style={{ flex: '0 0 80%' }}>
                  {remapOrderItems(val.order_items)}
                </Box>
              </Flex>
              <Box p={14}>
                <Text fz={12} fw={500} c='gray.6'>Package Quantity: {val.package_qty} {val.package_type}</Text>
              </Box>
            </Flex>
          </Box>
          <Box py={10}>
            <Group gap='sm' align='center' mb={14}>
              <ThemeIcon variant="light" radius="xl" size="lg" color='violet.8'>
                <IconBox style={{ width: '70%', height: '70%' }} />
              </ThemeIcon>
              <Title size={16} c='violet.8'>Package Detail</Title>
            </Group>
            <SimpleGrid cols={4} verticalSpacing="md" spacing="md" my={10}>
              <Box>
                <Text fz={12} c='gray.6'>Net Weight / Package</Text>
                <Text fz={12} fw='500'>{val.net_weight || '-'} KG</Text>
              </Box>
              <Box>
                <Text fz={12} c='gray.6'>Gross Weight / Package</Text>
                <Text fz={12} fw='500'>{val.gross_weight || '-'} KG</Text>
              </Box>
              <Box>
                <Text fz={12} c='gray.6'>Total Net Weight</Text>
                <Text fz={12} fw='500'>{val.total_net_weight || '-'} KG</Text>
              </Box>
              <Box>
                <Text fz={12} c='gray.6'>Total Gross Weight</Text>
                <Text fz={12} fw='500'>{val.total_gross_weight || '-'} KG</Text>
              </Box>
              <Box>
                <Text fz={12} c='gray.6'>CBM / Package</Text>
                <Text fz={12} fw='500'>{val.cbm || '-'}</Text>
              </Box>
              <Box>
                <Text fz={12} c='gray.6'>Total CBM</Text>
                <Text fz={12} fw='500'>{val.total_cbm || '0'}</Text>
              </Box>
              <Box>
                <Text fz={12} c='gray.6'>Dimension (W x H x L)</Text>
                <Text fz={12} fw='500'>{mappingDimensions(val.dimensions, val.unit_dimension)}</Text>
              </Box>
              <Box />
              {mappingShowUser(showUser)}
            </SimpleGrid>
          </Box>
        </SimpleGrid>
      </Card>
    )
  })
  return (
    <Box>
      {listData(packageItems)}
    </Box>
  )
}

export default PackageItemsList